export default "__VITE_ASSET__DbI7c0b___"